import outline from "../../../../assets/images/docs/outline.png";
import landmarks from "../../../../assets/images/blogs/pp12/landmarks.png";
import * as React from 'react';
export default {
  outline,
  landmarks,
  React
};